import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Input, Button, Table, Spin, Tag, Tooltip, Modal , Typography} from "antd";
import { PlusOutlined, SearchOutlined, EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import PassengersForm from "./passengersForm";
import { NavLink } from "react-router-dom";
import axios from "axios";
const { Title } = Typography;

const { Search } = Input;

const Passengers = () => {
  const [passengersData, setPassengersData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchPassengers();
  }, []);

  const fetchPassengers = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/passengers");
      setPassengersData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      message.error("Unable to load passengers!");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const lowerSearch = value.toLowerCase();
    const filtered = passengersData.filter((passenger) => {
      const fieldsToSearch = [
        passenger.firstName,
        passenger.lastName,
        passenger.phoneNumber,
        passenger.email,
        passenger.status,
      ];
      return fieldsToSearch.some((field) =>
        field?.toString().toLowerCase().includes(lowerSearch)
      );
    });
    setFilteredData(filtered);
  };

  const highlightText = (text, searchText) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = text.toString().split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} style={{ backgroundColor: "lightgreen", fontWeight: "bold" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const columns = [
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Customer ID</span>,
      dataIndex: "id",
      key: "id",
      render: (text) => highlightText(`#${text}`, searchText), // Prepend # to the Trip ID
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>First Name</span>,
      dataIndex: "firstName",
      key: "firstName",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Last Name</span>,
      dataIndex: "lastName",
      key: "lastName",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Phone Number</span>,
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (text) => highlightText(text, searchText),
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Status</span>,
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const color =
          status === "Active"
            ? "green"
            : status === "Pending"
            ? "orange"
            : status === "Inactive"
            ? "red"
            : "green";
        return (
          <Tag color={color}>{highlightText(status?.toUpperCase() || "Active", searchText)}</Tag>
        );
      },
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditPassenger(record)}
            style={{ color: "#0c8c49" }}
          >
            Edit
          </Button>
          <Button type="link">
            <NavLink
              to={`/passengerDetails/${record.id}`}
              style={{ color: "#0c8c49" }}
            >
              <InfoCircleOutlined /> Details
            </NavLink>
          </Button>
        </>
      ),
    },
  ];

  const handleEditPassenger = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleAddPassenger = () => {
    setFormData({});
    setModalVisible(true);
  };

  return (
    <div style={{ padding: "20px" }}>
    <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Customers
        </Title>
        <Row gutter={[16, 16]} align="middle" justify="space-between" style={{ marginBottom: "20px" }}>
          <Col span={18}>
            <Search
              placeholder="Search Passengers"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "60%" }}
            />
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddPassenger}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Passenger
            </Button>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            {loading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Spin size="large" />
              </div>
            ) : (
              <Table
                columns={columns}
                dataSource={filteredData}
                rowKey="id"
                pagination={{ pageSize: 5 }}
                bordered
              />
            )}
          </Col>
        </Row>
      </Card>

      {/* Add/Edit Passenger Modal */}
      <Modal
        title={
          formData.id ? (
            <span style={{ color: "#aa0077" }}>Edit Passenger</span>
          ) : (
            <span style={{ color: "#aa0077" }}>Add Passenger</span>
          )
        }
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={800}
      >
        <PassengersForm
          formData={formData}
          setFormData={setFormData}
          closeModal={() => setModalVisible(false)}
          refetchData={fetchPassengers}
        />
      </Modal>
    </div>
  );
};

export default Passengers;
